import { isNullUndefined } from "@/main/services/utils";

export function isValidNumberValue(value: string) {
	if (isNullUndefined(value)) return false;
	return /^-?[0-9]*[.,]?[0-9]*$/.test(value);
}

export function valueWithNumberCommaNegative(value: string) {
	if (isNullUndefined(value)) return "";
	return value.replace(/[^\d.,-]/g, "");
}

export function removeCommaDot(value: string | null) {
	if (isNullUndefined(value)) return "";
	return value.replace(/[,.]/g, "");
}
export function removeNegative(value: string | null) {
	if (isNullUndefined(value)) return "";
	return value.replace(/[^0-9.,]/g, "");
}

export function quantityNumbers(value: string | null) {
	if (isNullUndefined(value)) return 0;
	const numbersBeforeCommaOrDot = value.replace(/[,.].*$/, "");
	return numbersBeforeCommaOrDot.replace(/[^0-9]/g, "").length;
}

export function getSeparatorDecimal(value: string) {
	return value.includes(",") ? "," : ".";
}

export function hasComma(value: string) {
	return value.includes(",");
}
